export default {
  getWebClientSocketConnectionState: state => state.webClientSocketConnectionState,
  getWebClientProjectList: state => state.projectList,
  getWebClientProjectSearch: state => state.projectSearch,
  getResourceLoading: state => state.resourceLoading,
  getWebClientRegionList: state => state.regionList,
  getWebClientServerList: state => state.serverList,
  getResourceSearch: state => state.resourceSearch,
  getResourceResult: state => state.resourceResult,
  getWebClientRDSList: state => state.rdsList,
  getCurrentProject: state => state.currentProject,
  getCurrentResourceType: state => state.currentResourceType,
  getMachineInfo: state => state.machineInfo,
  getServerConnectionInformation: state => resourceKey => {
    if (resourceKey in state.serverConnectionList) {
      return state.serverConnectionList[resourceKey];
    }
    return {};
  },
  getRDSConnectionInformation: state => resourceKey => {
    if (resourceKey in state.rdsConnectionList) {
      return state.rdsConnectionList[resourceKey];
    }
    return {};
  },
  getWebClientDynamoDBList: state => state.dynamoDBList,
  getDynamoDBConnectionInformation: state => resourceKey => {
    if (resourceKey in state.dynamoDBConnectionList) {
      return state.dynamoDBConnectionList[resourceKey];
    }
    return {};
  },
  getWebClientS3List: state => state.s3List,
  getS3ConnectionInformation: state => resourceKey => {
    if (resourceKey in state.s3ConnectionList) {
      return state.s3ConnectionList[resourceKey];
    }
    return {};
  },
  getStorageAccountList: state => state.storageAccountList,
  getStorageAccountConnInfo: state => state.storageAccountConnList,
  getStorageAccountIpList: state => state.storageAccountIpList,
};



// WEBPACK FOOTER //
// ./src/vuex/webClient/webClientGetter.js